module.exports = ".action-button {\n  background-color: #fecc00;\n  color: #000;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  padding: 7px 30px;\n  margin-left: 2px;\n  margin-right: 2px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/approbation-group/approbation-group-detail/approbation-group-detail.component.scss
// module id = ./src/app/system/approbation-group/approbation-group-detail/approbation-group-detail.component.scss
// module chunks = main